<template>

    <div>
        <ui-modal v-ref:created-modal :width="400">
            <div slot="header">
                <i class="glyphicon glyphicon-user"></i>
                Negócio Criado
            </div>
            <div v-if="ui.createdCustomer">
                O negócio foi criado com sucesso e o responsável(<b>{{ui.createdCustomer.user.name}}</b>) notificado.
            </div>
            <div slot="footer">
                <button class="btn btn-default" type="button" @click="$refs.createdModal.hide()">Fechar</button>
                <a class="btn btn-primary" type="button" :href="ui.createdCustomerFormPath" v-if="ui.createdCustomer && ui.createdCustomer.editable">
                    Ver negócio
                </a>
                <a class="btn btn-primary" type="button" :href="'/customers/' + ui.createdCustomer.id" v-if="ui.createdCustomer && ui.createdCustomer.editable">
                    Ver cliente
                </a>
            </div>
        </ui-modal>
        <ui-modal v-ref:modal :width="400">
            <div slot="header">
                <i class="glyphicon glyphicon-user"></i>
                {{ title }}
            </div>
            <div>
                <ui-loading :state="ui.loading" text="Carregando...">
                    <form v-if="!ui.loading" name="customer" v-el:form @submit.prevent="submit">
                        <div class="row">
                            <div class="col-xs-12">
                                <div v-for="customer in ui.customersUsingThePhone">
                                    <div v-if="!customer.editable" class="alert alert-danger" style="margin: 0;">
                                        O cliente
                                        <b>{{customer.name}}</b>
                                        cadastrado pelo usuário
                                        <b>{{customer.user.name}}</b>
                                        está utilizando o telefone
                                        <b>{{ firstPhone(customer) }}</b>
                                    </div>
                                    <div v-if="customer.editable" class="alert alert-danger" @click="pick(customer)" style="margin: 0;">
                                        O cliente
                                        <b>{{customer.name}}</b>
                                        está utilizando o telefone
                                        <b>{{ firstPhone(customer) }}</b>
                                        <span v-if="customer.formsCount.opened">
                                            , e também possui
                                            <span>{{ customer.formsCount.opened | plural
                                            '%s atendimento'
                                            '%s atendimentos' }}
                                            </span>
                                            em aberto
                                        </span>
                                        , {{ ui.triggerMessage }}
                                    </div>
                                </div>
                                <div v-for="customer in ui.customersUsingTheEmail">
                                    <div v-if="!customer.editable" class="alert alert-danger" style="margin: 0;">
                                        O cliente
                                        <b>{{customer.name}}</b>
                                        cadastrado pelo usuário
                                        <b>{{customer.user.name}}</b>
                                        está utilizando o e-mail
                                        <b>{{ firstEmail(customer) }}</b>
                                    </div>
                                    <div v-if="customer.editable" class="alert alert-danger" @click="pick(customer)" style="margin: 0;">
                                        O cliente
                                        <b>{{ customer.name }}</b>
                                        está utilizando o e-mail
                                        <b>{{ firstEmail(customer) }}</b>
                                        <span v-if="customer.formsCount.opened">
                                            , e também possui
                                            {{ customer.formsCount.opened | plural
                                        '%s atendimento'
                                        '%s atendimentos' }}
                                            em aberto
                                        </span>
                                        , {{ ui.triggerMessage }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input class="loud-error" type="hidden" data-field="customer.general">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <form-text :model.sync="customer.name"
                                           placeholder="Digite o nome"
                                           :large="true"
                                           icon-class="glyphicon glyphicon-user"
                                           v-ref:customer-name
                                           name="customer.name"></form-text>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="hidden" data-field="customer.phones" class="loud-error"/>
                                </div>
                            </div>
                            <div class="col-md-12"
                                 v-for="phone in customer.phones"
                                 :class="{'remove-form-group-margin': $index === customer.phones.length - 1}">
                                <div v-if="customer.phones.length > 1">
                                    <form-mask :model.sync="phone.phone"
                                                placeholder="Telefone"
                                                :large="true"
                                                icon-class="glyphicon glyphicon-earphone"
                                                mask="br_phones"
                                                :name="'customer.phone.' + $index">
                                        <span class="input-group-btn" slot="append">
                                            <button class="btn btn-default btn-lg"
                                                    type="button"
                                                    style="height: 46px;"
                                                    @click="removePhone(phone)">
                                                <i class="fa fa-trash" style="font-size: 20px;"></i>
                                            </button>
                                        </span>
                                    </form-mask>
                                </div>
                                <div v-if="customer.phones.length < 2">
                                    <form-mask :model.sync="phone.phone"
                                                placeholder="Telefone"
                                                :large="true"
                                                icon-class="glyphicon glyphicon-earphone"
                                                mask="br_phones"
                                                :name="'customer.phone.' + $index"></form-mask>
                                </div>
                            </div>
                            <div class="col-md-12" style="margin-bottom: 15px;">
                                <a class="pull-right" href="#" @click="addPhone()">+ adicionar mais um(a)</a>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="hidden" data-field="customer.emails" class="loud-error"/>
                                </div>
                            </div>


                            <div class="col-md-12"
                                 v-for="email in customer.emails"
                                 :class="{'remove-form-group-margin': $index === customer.emails.length - 1}">
                                <div v-if="customer.emails.length > 1">
                                    <form-text :model.sync="email.email"
                                               placeholder="E-mail"
                                               :large="true"
                                               icon-class="fa fa-envelope"
                                               :name="'customer.email.' + $index">
                                        <span class="input-group-btn" slot="append">
                                            <button class="btn btn-default btn-lg"
                                                    type="button"
                                                    style="height: 46px;"
                                                    @click="removeEmail(email)">
                                                <i class="fa fa-trash" style="font-size: 20px;"></i>
                                            </button>
                                        </span>
                                    </form-text>
                                </div>
                                <div v-if="customer.emails.length < 2">
                                    <form-text :model.sync="email.email"
                                               placeholder="E-mail"
                                               :large="true"
                                               icon-class="fa fa-envelope"
                                               :name="'customer.email.' + $index"></form-text>
                                </div>
                            </div>
                            <div class="col-md-12" style="margin-bottom: 15px;">
                                <a class="pull-right" href="#" @click="addEmail()">+ adicionar mais um(a)</a>
                            </div>
                            <div class="col-md-12 remove-form-group-margin" v-if="!withForm && showForm">
                                <form-check :model.sync="ui.createForm" label="Criar negócio"></form-check>
                            </div>


                            <div class="col-md-12 remove-form-group-margin" v-if="ui.createForm && ($can('manager.forms') || $can('manager.customers'))">
                                <form-check :model.sync="ui.routeForm" :label="onRouterMessage"></form-check>

                                <div style="position: relative">
                                    <div style="border-bottom: 1px solid #ccc; width: 100%; height: 1px; position: absolute; top: 50%; z-index: 0"></div>
                                    <div style="position: relative; z-index: 1; background: white; width: 30px; text-align: center; margin: 0 auto;">ou</div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="( $can('manager.forms') || $can('manager.customers') )">
                                <form-select :options.sync="ui.options.users"
                                             label="Responsável"
                                             :disabled="responsibleEnabled"
                                             :model.sync="customer.user_id"></form-select>
                            </div>
                            <div class="col-md-12" v-if="ui.routeForm">
                                <form-text :model.sync="ui.propertyCode"
                                           placeholder="Código do imóvel que o cliente pode se interessar"
                                           icon-class="glyphicon glyphicon-home"
                                           name="ui.propertyCode"></form-text>
                            </div>

                            <div class="col-md-12 remove-form-group-margin">
                                <form-select :options.sync="filteredContactSources"
                                             label="Origem do contato"
                                             name="customer.contact_source"
                                             :model.sync="customer.contact_source"></form-select>
                            </div>
                        </div>
                        <input class="hidden-submit-input" type="submit" tabindex="-1">
                    </form>
                </ui-loading>
            </div>
            <div slot="footer">
                <button class="btn btn-default" type="button" @click="hide()">Cancelar</button>
                <button class="btn blue" type="button" disabled v-if="ui.saving">
                    Enviando...
                </button>
                <button class="btn blue" type="button" @click="submit" v-if="!ui.saving">
                    Continuar
                    <i class="fa fa-arrow-circle-right"></i>
                </button>
            </div>
        </ui-modal>
    </div>
</template>
<script type="text/babel">
    import {get} from "lodash";

    const R = require('ramda')
    const Validator = require('sci/helpers/validator')
    const Promise = require('bluebird')
    const client = require('sci/helpers/client')
    const location = window.location
    const vueChaos = require('sci/helpers/vue-chaos')
    const x9 = require('microsistec/x9')
    const SCI = require('sci')
    const instance = SCI.get('instance')
    const me = SCI.get('user')

    const phoneDefault = {
        phone: null
    }

    const emailDefault = {
        email: null
    }

    const defaultCustomer = {
        user_id: me.id,
        contact_source: null,
        name: null,
        emails: [R.clone(emailDefault)],
        phones: [R.clone(phoneDefault)]
    }

    const phoneValidator = R.memoize((index) => new Validator({
        'rules': {
            [`phone.${index}`]: 'nullable|br_phones'
        },
        'messages': [],
        'attributes': {
            [`phone.${index}`]: 'Telefone'
        }
    }))

    const emailValidator = R.memoize((index) => new Validator({
        'rules': {
            [`email.${index}`]: 'nullable|email'
        },
        'messages': [],
        'attributes': {
            [`email.${index}`]: 'E-mail'
        }
    }))

    const nameValidator = new Validator({
        'rules': {
            'name': 'required'
        },
        'messages': [],
        'attributes': {
            'name': 'Nome'
        }
    })

    export default {
        props: {
            withForm: {
                type: Boolean,
                default: false
            },
            created: {
                type: Function
            },
            mode: {
                type: String
            },
            title: {
                type: String,
                default: 'Cadastrar novo cliente'
            },
            showForm: {
                type: Boolean,
                default: true
            },
            userId: {
                default: null
            },
            routeForm: {
                default: false
            },
            propertyCode: {
                default: null
            }
        },
        data: () => ({
            customer: R.clone(defaultCustomer),
            ui: {
                preSaleEnabled: get(instance.overrides, 'sci.settings.form-routing.pre-sale'),
                createdCustomerFormPath: null,
                createdCustomer: null,
                routeForm: false,
                loading: true,
                saving: false,
                createForm: false,
                invalids: [],
                propertyCode: null,
                customersUsingThePhone: [],
                customersUsingTheEmail: [],
                triggerMessage: 'clique nesse alerta para usar esse cadastro.',
                options: null
            }
        }),
        ready () {
            this.customer.user_id = this.userId || this.$user.id

            this.ui.withForm = this.withForm

            if (this.withForm) {
                this.ui.triggerMessage = 'clique nesse alerta para ir até o atendimento.'
                this.ui.createForm = true
            }
        },
        methods: {
            validate () {
                return this.validateName()
                    .then(() => this.validatePhones())
                    .then(() => this.validateEmails())
                    .then(() => this.validateGeneral())
            },
            submit () {
                if (this.ui.saving) {
                    return
                }

                this.ui.saving = true
                this.validate().then(() => {
                    const customerToSave = {
                        name: this.customer.name,
                        contact_source: this.customer.contact_source,
                        type: this.customer.type || 1,
                        owner: !!this.customer.owner,
                        interested: !!this.customer.interested,
                        building_builder: !!this.customer.building_builder,
                        building_developer: !!this.customer.building_developer,
                        building_manager: !!this.customer.building_manager,
                        phones: this.customer.phones.filter(_ => !!_.phone),
                        emails: this.customer.emails.filter(_ => !!_.email),
                        with_form: this.ui.createForm,
                        route_form: this.ui.routeForm,
                        property_code: this.ui.propertyCode,
                        user_id: this.customer.user_id
                    }

                    client
                        .silent()
                        .block(this.$els.form)
                        .post('Salvando...', '/customers', customerToSave)
                        .then(vueChaos(this.$els.form, false))
                        .then((res) => {
                            this.ui.customersUsingThePhone = []
                            this.ui.customersUsingTheEmail = []

                            this.pick(res.data)

                            this.ui.saving = false

                            if (this.ui.routeForm) {
                                if (res.data.forms && res.data.forms.length > 0) {
                                    this.ui.createdCustomerFormPath = `/forms/${res.data.forms[res.data.forms.length  - 1].id}`
                                } else {
                                    this.ui.createdCustomerFormPath = null
                                }
                                this.ui.createdCustomer = res.data
                                this.$refs.createdModal.show()
                            }
                        })
                        .catch((ex) => {
                            x9.report(ex)
                            const res = ex.data
                            if (res) {
                                if (res.errors && res.errors.length > 0) {
                                    if (res.meta) {
                                        if (res.meta.hasOwnProperty('customers_phones')) {
                                            this.ui.customersUsingThePhone = res.meta.customers_phones
                                        }

                                        if (res.meta.hasOwnProperty('customers_emails')) {
                                            this.ui.customersUsingTheEmail = res.meta.customers_emails
                                        }
                                    }
                                } else {
                                    this.pick(res.data)
                                }
                            }

                            this.ui.saving = false
                        })
                }).catch(() => {
                    this.ui.saving = false
                })
            },
            show (data = {}) {
                this.ui.invalids = []
                this.ui.customersUsingTheEmail = []
                this.ui.customersUsingThePhone = []
                this.customer = {
                    ...R.clone(defaultCustomer),
                    ...R.clone(data),
                    user_id: this.userId || this.$user.id
                }

                if (this.ui.options === null) {
                    this.ui.loading = true
                    client
                        .get(null, '/customers/options')
                        .then(({ data }) => {
                            this.ui.options = data
                            this.ui.loading = false

                            this.$refs.modal.show().then(() => {
                                this.$refs.customerName.focus()
                            })
                        })
                } else {
                    this.$refs.modal.show().then(() => {
                        this.$refs.customerName.focus()
                    })
                }
            },
            addPhone () {
                this.customer.phones.push(R.clone(phoneDefault))
            },
            addEmail () {
                this.customer.emails.push(R.clone(emailDefault))
            },
            removePhone (phone) {
                this.customer.phones.$remove(phone)
            },
            removeEmail (phone) {
                this.ui.invalids = this.ui.invalids.filter(_ => _.indexOf('email.') !== 0)
                this.customer.emails.$remove(phone)
            },
            validateName () {
                this.ui.invalids.$remove('name')

                return nameValidator
                    .validateForm(this.$els.form, {
                        'name': this.customer.name
                    }, false)
                    .catch((ex) => {
                        this.ui.invalids.push('name')

                        throw ex
                    })
            },
            validatePhones () {
                const phones = this.customer.phones

                return Promise.map(phones, (item, index) => {
                    this.ui.invalids.$remove(`phone.${index}`)

                    const validator = phoneValidator(index)

                    return validator
                        .validateForm(this.$els.form, {
                            [`phone.${index}`]: item.phone
                        }, false)
                        .then(() => {
                            const exceptCurrent = phones.filter(_ => _ !== item)

                            if (exceptCurrent.filter(_ => _.phone === item.phone).length) {
                                validator.throw(this.$els.form, `phone.${index}`, 'Telefone já adicionado')
                            }
                        })
                        .catch((ex) => {
                            this.ui.invalids.push(`phone.${index}`)

                            throw ex
                        })
                })
            },
            validateEmails () {
                const emails = this.customer.emails

                return Promise.map(emails, (item, index) => {
                    this.ui.invalids.$remove(`email.${index}`)

                    const validator = emailValidator(index)

                    return validator
                        .validateForm(this.$els.form, {
                            [`email.${index}`]: item.email
                        }, false)
                        .then(() => {
                            const exceptCurrent = emails.filter(_ => _ !== item)

                            if (exceptCurrent.filter(_ => _.email === item.email).length) {
                                validator.throw(this.$els.form, `email.${index}`, 'E-mail já adicionado')
                            }
                        })
                        .catch((ex) => {
                            this.ui.invalids.push(`email.${index}`)

                            throw ex
                        })
                })
            },
            validateGeneral () {
                return new Promise((resolve, reject) => {
                    if (this.customer.phones.length < 1) {
                        nameValidator.throw(this.$els.form, `general`, 'Necessário pelo menos 1 telefone', true)
                    }

                    resolve()
                })
            },
            firstPhone (customer) {
                return R.head(customer.phones_in_use)
            },
            firstEmail (customer) {
                return R.head(customer.emails_in_use)
            },
            pick (customer) {
                switch (this.mode) {
                    case 'create':

                        if (this.created && customer.forms && customer.forms.length > 0) {
                            this.created(customer, false)
                        }

                        if (this.created) {
                            this.created(customer, this.ui.routeForm)
                        }

                        this.$refs.modal.hide()
                        break
                    default:
                        if (this.ui.routeForm) {
                            return
                        }

                        if (customer.formsCount.opened) {
                            const form = R.head(customer.forms)
                            location.href = `/forms/${form.id}`
                            return
                        }

                        location.href = `/customers/${customer.id}/editor`
                }
            },
            hide () {
                this.$refs.modal.hide()
            }
        },
        computed: {
            onRouterMessage() {
                if (this.ui.preSaleEnabled) {
                    return "Enviar para pre-vendas"
                }
                return 'Entrar no rodízio'
            },
            responsibleEnabled() {
                if (this.ui.preSaleEnabled) {
                    return false;
                }

                return this.ui.routeForm
            },
            hasInvalid () {
                return this.ui.invalids.length > 0
            },
            filteredContactSources () {
                this.customer.contact_source = null
                if (this.ui.routeForm) {
                    return this.ui.options.contact_sources.filter(_ => !!_.form_source)
                } else {
                    return this.ui.options.contact_sources
                }
            }
        },
        watch: {
            'customer.user_id' (newVal, oldVal) {
            },
            'userId' () {
                this.customer.user_id = this.userId || this.$user.id
            },
            'customer.name' () {
                this.validateName()
            },
            'customer.phones': {
                deep: true,
                handler () {
                    this.validatePhones()
                }
            },
            'customer.emails': {
                deep: true,
                handler () {
                    this.validateEmails()
                }
            },
        }
    }

</script>



// WEBPACK FOOTER //
// QuickForm.vue?4a498d28